import  TablaPosMisQuinielaGrupo from './TablaPosMisQuinielaGrupo';

export default TablaPosMisQuinielaGrupo;